export function formatClientDate(client) {
  let date = new Date(client)
  let day = String(date.getUTCDate()).padStart(2, '0')
  let month = String(date.getUTCMonth() + 1).padStart(2, '0') // Месяцы начинаются с 0
  let year = date.getUTCFullYear()
  let hours = String(date.getUTCHours()).padStart(2, '0')
  let minutes = (Math.ceil(date.getUTCMinutes() / 5) * 5) % 60

  if (minutes === 0 && date.getUTCMinutes() !== 0) {
    hours = String(parseInt(hours) + 1).padStart(2, '0')
  }

  minutes = String(minutes).padStart(2, '0')

  return `${day}.${month}.${year} ${hours}:${minutes}`
}
